import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getFitnessTrainings ({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/trainings')).data
      return response
    },

    async getExercisesForTheDay ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/trainings/exercisesForDay', options)).data
      return response
    },

    async getTrackingDetails ({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/fitnesstrackers/patientId/' + options.patientId + '/trainingId/' + options.trainingId + '/_gettrackingdetails', options)).data
      return response
    },

    async startFitnessTracker ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/fitnesstrackers/_starttracking', {
        training: this.state.training._id,
        day: this.state.currentTrainingDayIndex + 1,
        exercise: options.exerciseId
      })).data
      return response
    },


    async stopFitnessTracker ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/fitnesstrackers/_stoptracking', {
        training: this.state.training._id,
        day: this.state.currentTrainingDayIndex + 1,
        exercise: options.exerciseId
      })).data
      return response
    },

    // yoga functions
    async getYogaTrainings ({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/trainingsyoga')).data
      return response
    },

    async getYogaExercisesForTheDay ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/trainingsyoga/exercisesForDay', options)).data
      return response
    },

    async getYogaTrackingDetails ({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/yogatrackers/patientId/' + options.patientId + '/trainingId/' + options.trainingId + '/_gettrackingdetails', options)).data
      return response
    },

    async startYogaTracker ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/yogatrackers/_starttracking', {
        training: this.state.training._id,
        day: this.state.currentTrainingDayIndex + 1,
        exercise: options.exerciseId
      })).data
      return response
    },

    async stopYogaTracker ({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/yogatrackers/_stoptracking', {
        training: this.state.training._id,
        day: this.state.currentTrainingDayIndex + 1,
        exercise: options.exerciseId
      })).data
      return response
    },

    async getFitnessTrackers ({ }, patientId) {
      let response = (await Vue.http.get(this.state.baseUrl + '/fitnesstrackers/patientId/' + patientId)).data
      return response
    },

    async getYogaTrackers ({ }, patientId) {
      let response = (await Vue.http.get(this.state.baseUrl + '/yogatrackers/patientId/' + patientId)).data
      return response
    },

  }
}
